export default __webpack_public_path__ + "static/media/logo-dark.9ed54027.png";